import React, { useState } from "react";
import Cart from "../../pages/Cart";

function QrCart({ cart, setCart, joinToken, setJoinToken }) {
  const [form, setForm] = useState({
    name: "",
    phoneNumber: "",
    email: "",
  });

  return (
    <Cart
      cart={cart}
      setCart={setCart}
      form={form}
      setForm={setForm}
      phoneNumber=""
      loggedIn={false}
      restaurantStatus="online"
      isDineIn={true}
      joinToken={joinToken}
      setJoinToken={setJoinToken}
    />
  );
}

export default QrCart;
